import { atom } from "jotai";

import type { AuthUser } from "@/types/auth";

/**
 * Browser PWA only: auth is the HttpOnly `eriol_session` cookie that the
 * backend sets on login. JS can't read it (that's the point), so the user
 * atom — populated from /auth/me — is the source of truth.
 * (Guest's Electron accessKey machinery was intentionally dropped.)
 */
export const userAtom = atom<AuthUser | null>(null);

/**
 * Tri-state validation:
 *   - "pending": at mount, before /auth/me resolves
 *   - "valid": /auth/me succeeded (or there is no session at all)
 *   - "invalid": backend rejected the session → force logout
 */
export type AuthValidationState = "pending" | "valid" | "invalid";

export const authValidationStateAtom = atom<AuthValidationState>("pending");

export const isAuthenticatedAtom = atom((get) => {
  const hasUser = get(userAtom) !== null;
  if (!hasUser) return false;
  return get(authValidationStateAtom) !== "invalid";
});
